import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-laptop-savepopup',
  templateUrl: './laptop-savepopup.component.html',
  styleUrls: ['./laptop-savepopup.component.scss']
})
export class LaptopSavepopupComponent implements OnInit {
  flag: string;

  constructor(
  public dialog: MatDialog,
  private toaster: ToastrService,
  public dialogRef: MatDialogRef<LaptopSavepopupComponent>,
  ) { }

  ngOnInit(): void {
    this.flag = localStorage.getItem('flag');  // returns "0" or "1"

  }
  close()
  {
    this.dialogRef.close(false);

  }
}
